import React from 'react';

export const LoadableContext = React.createContext();

export default LoadableContext;